import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M0 2.538A2.544 2.544 0 0 1 2.538 0h11.077a2.544 2.544 0 0 1 2.539 2.538v4.616a.692.692 0 1 1-1.385 0V2.538a1.16 1.16 0 0 0-1.154-1.153H2.538a1.16 1.16 0 0 0-1.153 1.153v12.923c0 .634.52 1.154 1.153 1.154h4.616a.692.692 0 1 1 0 1.385H2.538A2.544 2.544 0 0 1 0 15.461z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M13.934 10.613c.55-.55 1.396-.55 1.945 0l1.477 1.477c.55.55.55 1.395 0 1.945l-3.282 3.282a.95.95 0 0 1-.45.35c-.18.073-.378.103-.563.103h-2.4a.46.46 0 0 1-.462-.462v-2.4c0-.192.033-.373.11-.545a1.4 1.4 0 0 1 .302-.427zm1.293.652a.43.43 0 0 0-.64 0l-3.323 3.324a.5.5 0 0 0-.112.15.4.4 0 0 0-.03.17v1.938h1.939a.6.6 0 0 0 .248-.049.5.5 0 0 1 .072-.093l3.323-3.323a.43.43 0 0 0 0-.64zm-1.91 5.527v.001M8.079 8.539c.255 0 .461.206.461.461v2.77a.461.461 0 1 1-.923 0V9c0-.255.207-.461.462-.461",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0000E7",
  "fill-rule": "evenodd",
  d: "M6.23 10.385c0-.255.207-.461.462-.461h2.77a.462.462 0 1 1 0 .923h-2.77a.46.46 0 0 1-.462-.462M4.848 4.384c0-.255.206-.461.461-.461h5.539a.462.462 0 0 1 0 .923H5.309a.46.46 0 0 1-.461-.462",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }